import { z } from 'zod'

const authorityId = z.string().regex(/^nhrlink_v1_[a-f0-9]{64}$/)
const serviceIntent = z.string().regex(/^[A-Z][A-Z0-9_]{0,63}$/)

export const bookingOptionsRequestSchema = z
  .object({
    patientAuthorityId: authorityId,
    serviceIntent,
    patientType: z.enum(['NEW', 'EXISTING']),
    startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    patientAgeYears: z.number().int().min(0).max(130).nullable(),
  })
  .strict()

export const bookingOptionSchema = z
  .object({
    slotProofId: z.string().regex(/^nhslot_v1_[A-Za-z0-9_-]{40,64}$/),
    start: z.string().min(1),
    end: z.string().min(1),
    timeZone: z.string().min(1),
    providerName: z.string().nullable(),
    appointmentTypeName: z.string().nullable(),
    operatoryName: z.string().nullable(),
  })
  .strict()

export const bookingOptionsResponseSchema = z
  .object({
    schemaVersion: z.literal(1),
    serviceIntent,
    serviceLabel: z.string().nullable(),
    requestedDate: z.string().nullable(),
    resolvedDate: z.string().nullable(),
    timeZone: z.string().nullable(),
    options: z.array(bookingOptionSchema).max(20),
  })
  .strict()

export const bookAppointmentRequestSchema = z
  .object({
    patientAuthorityId: authorityId,
    serviceIntent,
    patientType: z.enum(['NEW', 'EXISTING']),
    slotProofId: z.string().regex(/^nhslot_v1_[A-Za-z0-9_-]{40,64}$/),
    patientAgeYears: z.number().int().min(0).max(130).nullable(),
    dashboardSessionId: z.string().uuid(),
    confirmedAtMs: z.number().int().positive(),
  })
  .strict()

export const bookAppointmentResponseSchema = z
  .object({
    schemaVersion: z.literal(1),
    outcome: z.literal('CONFIRMED'),
    appointmentReference: z.string().min(1),
    start: z.string().nullable(),
    end: z.string().nullable(),
    timeZone: z.string().nullable(),
  })
  .strict()

export type BookingOptionsRequest = z.infer<typeof bookingOptionsRequestSchema>
export type BookingOption = z.infer<typeof bookingOptionSchema>
export type BookingOptionsResponse = z.infer<
  typeof bookingOptionsResponseSchema
>
export type BookAppointmentRequest = z.infer<
  typeof bookAppointmentRequestSchema
>
export type BookAppointmentResponse = z.infer<
  typeof bookAppointmentResponseSchema
>
